module.exports = __webpack_public_path__ + "img/bkg.afb31b15.jpg";